import {
  buildApplicationCreateCreatePath,
  buildApplicationCreatePublicCreatePath,
  buildApplicationCreateStaffCreatePath,
} from '../../generated/schooly-api-v1/api-paths';

export const applicationCreateStaffPath = buildApplicationCreateStaffCreatePath;
export const applicationCreatePublicPath = buildApplicationCreatePublicCreatePath;
export const applicationCreatePath = buildApplicationCreateCreatePath;
